import type { RouteObject } from "react-router-dom";
import NotFound from "../pages/NotFound";
import Home from "../pages/home/page";
import LandingPage from "../pages/landing/page";
import ExperimentsPage from "../pages/experiments/page";
import ExperimentDetailPage from "../pages/experiments/detail/page";
import WorkflowCreatePage from "../pages/workflows/create/page";
import KnowledgePage from "../pages/knowledge/page";
import KnowledgeImportPage from "../pages/knowledge/import/page";
import KnowledgeDetailPage from "../pages/knowledge/detail/page";
import KnowledgeItemPage from "../pages/knowledge/item/page";
import NoteDetailPage from "../pages/knowledge/note/page";
import NoteEditPage from "../pages/knowledge/note/edit/page";
import KnowledgeAchievementPage from "../pages/knowledge/achievement/page";
import CogNetPage from "../pages/cognet/page";
import InnovationLayout from "../pages/innovation/layout";
import InnovationOverview from "../pages/innovation/pages/Overview";
import InnovationWorkbench from "../pages/innovation/pages/Workbench";
import InnovationRecordsHome from "../pages/innovation/pages/RecordsHome";
import InnovationRecordDetail from "../pages/innovation/pages/RecordDetail";
import InnovationCreateWizard from "../pages/innovation/pages/InnovationCreateWizard";
import { InnovationShareKnowledge, InnovationShareLink } from "../pages/innovation/pages/SharePages";
import { flattenLeaves, innovationNavTree } from "../pages/innovation/nav-config";

const innovationWorkbenchRoutes = flattenLeaves(innovationNavTree)
  .filter((l) => l.path !== "/innovation/records" && !l.path.startsWith("/innovation/records/share"))
  .map((l) => ({
    path: l.path.replace(/^\/innovation\/?/, ""),
    element: <InnovationWorkbench key={l.path} />,
  }));

const routes: RouteObject[] = [
  {
    path: "/",
    element: <Home />,
  },
  {
    path: "/landing",
    element: <LandingPage />,
  },
  {
    path: "/experiments",
    element: <ExperimentsPage />,
  },
  {
    path: "/experiments/:id",
    element: <ExperimentDetailPage />,
  },
  {
    path: "/workflows/create",
    element: <WorkflowCreatePage />,
  },
  {
    path: "/knowledge",
    element: <KnowledgePage />,
  },
  {
    path: "/knowledge/import",
    element: <KnowledgeImportPage />,
  },
  {
    path: "/knowledge/:id",
    element: <KnowledgeDetailPage />,
  },
  {
    path: "/knowledge/item/:itemId",
    element: <KnowledgeItemPage />,
  },
  {
    path: "/knowledge/note/:id",
    element: <NoteDetailPage />,
  },
  {
    path: "/knowledge/note/:id/edit",
    element: <NoteEditPage />,
  },
  {
    path: "/knowledge/achievement/:id",
    element: <KnowledgeAchievementPage />,
  },
  {
    path: "/cognet",
    element: <CogNetPage />,
  },
  {
    path: "/innovation",
    element: <InnovationLayout />,
    children: [
      { index: true, element: <InnovationOverview /> },
      { path: "create", element: <InnovationCreateWizard /> },
      ...innovationWorkbenchRoutes,
      { path: "records/share/link", element: <InnovationShareLink /> },
      { path: "records/share/knowledge", element: <InnovationShareKnowledge /> },
      { path: "records/:recordId", element: <InnovationRecordDetail /> },
      { path: "records", element: <InnovationRecordsHome /> },
    ],
  },
  {
    path: "*",
    element: <NotFound />,
  },
];

export default routes;
